import styled from '@emotion/styled'

import Box from './Box'

const Flex = styled(Box)`
  display: flex;
`

export default Flex
